module.exports = __webpack_public_path__ + "img/energetic-driver.7bbf1362.svg";